import { css } from 'styled-components';
import { Breakpoint, BreakpointKey } from './breakpoints';

export const cssBreakpoint = (...breakpoints: Array<Breakpoint | BreakpointKey>) => {
    const condition = breakpoints.map((x) => (typeof x === `string` ? Breakpoint[x].toMediaQuery() : x.toMediaQuery())).join(`, `);
    return ((...args: Parameters<typeof css>) => css`@media ${condition} { ${css(...args)} }`);
};
